import { ISODateString } from "@novel/shared/interfaces/shared/ISODateString";
import { createTimer } from "@novel/shared/utils/createTimer";
import React, { useState, useEffect } from "react";
interface CountdownProps {
  readonly breakOnIn?: boolean;
  readonly prependStr?: string;
  readonly countdownTo: ISODateString | Date;
}
export function Countdown({
  prependStr,
  breakOnIn,
  countdownTo
}: CountdownProps): JSX.Element {
  const [countdownString, setCountdownString] = useState("");
  useEffect(() => {
    const countdownToDate = countdownTo instanceof Date ? countdownTo : ISODateString.fromString(countdownTo).toJSDate();
    return createTimer(countdownToDate, setCountdownString);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdownTo.toString()]);
  const calculatedStr = `${prependStr ? `${prependStr} ` : ""}${countdownString}`;
  if (breakOnIn) {
    const [beforeIn, afterIn] = calculatedStr.split("in");
    const cleanedAfterIn = afterIn ? afterIn.trim() : "";
    return <React.Fragment>
                {`${beforeIn}${cleanedAfterIn ? "in" : ""}`}
                {cleanedAfterIn && <br />}
                {cleanedAfterIn}
            </React.Fragment>;
  }
  return <React.Fragment>{calculatedStr}</React.Fragment>;
}